"use client";

import { AuthPageLayout, Card } from "components/ui/v2";
import RegisterForm from "components/Modal/Register/RegisterForm";
import ToggleLang from "components/ToggleLang/ToggleLang";
import ToggleTheme from "components/ToggleTheme/ToggleTheme";
import { useUserStoreContext } from "context/userStore/userStore.provider";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { PUBLIC_ROUTES } from "routes/routes";
import LoginForm from "../../classic/Login/Form";
import BrandPanelAurora from "./components/NewVendor/BrandPanelAurora";
import OrganizationFormAurora from "./components/NewVendor/OrganizationFormAurora";

type TStep1Mode = "register" | "login";

export default function NewOrganizationAurora() {
  const [step1Mode, setStep1Mode] = useState<TStep1Mode>("register");
  const [stepIndex, setStepIndex] = useState<number>(1);
  const { t } = useTranslation("vendor");
  const router = useRouter();

  const { user } = useUserStoreContext((store) => ({
    ...store,
  }));
  useEffect(() => {
    if (user && stepIndex === 1) {
      setStepIndex(2);
    }
  }, [user]);

  const handleCallback = (error?: string) => {
    if (!error) {
      setStepIndex(stepIndex + 1);
    } else {
      toast.error(error);
    }
  };

  return (
    <AuthPageLayout
      scenery="aurora"
      controls={
        <>
          <ToggleLang />
          <ToggleTheme />
        </>
      }
    >
      <div className="grid w-full max-w-[980px] items-center gap-8 md:grid-cols-2">
        <BrandPanelAurora />

        <Card variant="glow" size="full" entranceAnimation>
          {stepIndex === 1 && (
            <>
              {step1Mode === "register" && (
                <div className="grid gap-2">
                  <h3 className="text-balance text-center text-2xl font-bold">
                    {t("Crea tu cuenta de Administrador")}
                  </h3>
                  <span className="my-3 text-center text-sm text-slate-500 dark:text-zinc-400">
                    {t(
                      "Solo un pasos más para crear tu cuenta de administrador y tener el control de Groowcity"
                    )}
                  </span>
                  <RegisterForm callback={(e) => handleCallback(e)} />
                  <div className="flex w-full justify-center gap-1 py-3 text-center text-sm">
                    <p>{t("¿Ya tienes una cuenta?")}</p>
                    <a
                      className="ml-1 cursor-pointer self-center font-semibold text-primary"
                      onClick={() =>
                        router.push({
                          pathname: PUBLIC_ROUTES.vendorSelector.path,
                        })
                      }
                      aria-hidden
                    >
                      {t("Inicia sesión")}
                    </a>
                  </div>
                </div>
              )}

              {step1Mode === "login" && (
                <div className="w-full">
                  <h3 className="mb-6 text-2xl font-bold">
                    {t("Inicia sesión")}
                  </h3>
                  <LoginForm callback={handleCallback} />
                  <div className="flex w-full justify-center gap-1 py-3 text-center text-sm">
                    <p>{t("¿No tienes cuenta?")}</p>
                    <a
                      className="ml-1 cursor-pointer self-center font-semibold text-primary"
                      onClick={() => setStep1Mode("register")}
                      aria-hidden
                    >
                      {t("¡Regístrate!")}
                    </a>
                  </div>
                </div>
              )}
            </>
          )}

          {stepIndex === 2 && (
            <OrganizationFormAurora callback={handleCallback} />
          )}
        </Card>
      </div>
    </AuthPageLayout>
  );
}
